// libraries
import styled from "styled-components";
import { BORDER_RADIUS } from "~/constants";


export const Container = styled.div`
    width: 100%;
    padding: 10px;
    flex: 1;
    box-sizing: border-box;
    border-radius: ${BORDER_RADIUS}px;
    background-color: rgba(4,149,101,0.09);
    border: 2px solid ${props => props.theme.colors["primary"].rgba};
    
    margin-bottom: 20px;& > :not(:last-child) {
        margin-bottom: 15px;
    }
`;

export const Title = styled.div`
    color: ${props => props.theme.colors["primary"].rgba};
    font-size: 16px;
    font-weight: 600;
`;

export const Message = styled.div`
    color: ${props => props.theme.colors["text-primary"].rgba};
    font-size: 16px;
    font-weight: 400;
    margin-top: 10px;
`;

export const MessageWrapper = styled.div`

    
`;